// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dPx1","fullView":"styles_fullView__V01GO"};